import React from 'react';

/**
 * Lowercase bold wordmark with a hand-drawn SVG squiggle underline.
 * Defaults are tuned for the Chilli navbar (butter text + mustard squiggle).
 */
export const Wordmark = ({
  text = 'gathered things',
  textClass = 'text-primary group-hover:text-chilli-deep',
  squiggleClass = 'text-mustard',
  size = 'text-2xl md:text-[1.7rem]',
}) => (
  <span className="relative inline-flex flex-col items-start group" data-testid="wordmark">
    <span className={`lowercase font-display font-extrabold tracking-tight leading-none z-10 transition-colors duration-300 ${size} ${textClass}`}>
      {text}
    </span>
    <svg
      className={`absolute -bottom-2 left-0 w-full opacity-90 group-hover:opacity-100 transition-opacity ${squiggleClass}`}
      viewBox="0 0 100 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <path
        d="M2 9C20 2 40 10 60 4C75 0 90 8 98 8"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);
